import { render, staticRenderFns } from "./ComboSlider.vue?vue&type=template&id=47b6663c&"
import script from "./ComboSlider.vue?vue&type=script&lang=js&"
export * from "./ComboSlider.vue?vue&type=script&lang=js&"
import style0 from "./ComboSlider.vue?vue&type=style&index=0&id=47b6663c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports